// Port of api/fuel/app/classes/controller/api/monty/session/syncs.php
import Constants from 'offline/constants'
import DB from 'offline/db'
import InsightUserSync from 'offline/model/insight/user/sync'
import SyncResult from 'offline/model/sync/result'
import User from 'offline/model/user'
import Util from 'offline/util'

function currentUser(params) {
	var uid = params.sessionUserId || DB.meta('sync_user_id') || false
	return uid ? User.with_id(uid) : null
}

function parseJson(value, fallback) {
	if (value === null || value === undefined || value === '') return fallback
	if (typeof value === 'object') return value
	try {
		return JSON.parse(value)
	} catch (e) {
		return fallback
	}
}

function isAuto(priority) {
	return priority >= Constants.SYNC_PRIORITY_USER_AUTO && priority <= Constants.SYNC_PRIORITY_USER_AUTO_UPGRADE + 1
}

function userType(result) {
	if (result.result_type === 'deep') return 'Deep'
	var params = parseJson(result.result_params, {})
	if (params.recent) return 'Recent'
	return 'Full'
}

function historyRow(result) {
	return {
		date: parseInt(result.result_date || 0, 10),
		success: parseInt(result.result_success || 0, 10),
		auto: isAuto(parseInt(result.result_priority || 0, 10)),
		type: userType(result),
		timeline: {
			queued: parseInt(result.result_date_queued || 0, 10),
			scraped: parseInt(result.result_date_scraped || 0, 10),
			processed: parseInt(result.result_date || 0, 10)
		},
		metrics: {
			processing: parseFloat(result.result_time_process || 0),
			scraping: parseFloat(result.result_time_scraped || 0),
			size: parseInt(result.result_size || 0, 10)
		},
		changes: parseJson(result.result_changes, {})
	}
}

function nextSyncText(user, lastAutoSyncDate) {
	var days = {
		1: 'Monday',
		2: 'Tuesday',
		3: 'Wednesday',
		4: 'Thursday',
		5: 'Friday',
		6: 'Saturday',
		7: 'Sunday'
	}
	var times = {
		1: '12am',
		2: '2am',
		3: '4am',
		4: '6am',
		5: '8am',
		6: '10am',
		7: '12pm',
		8: '2pm',
		9: '4pm',
		10: '6pm',
		11: '8pm',
		12: '10pm'
	}

	var zone = user.get_sync_zone() || 'UTC'
	var baseDate = new Date((lastAutoSyncDate || Util.time()) * 1000)
	var nowDate = new Date(Util.time() * 1000)

	function weekdayInZone(date) {
		var formatter = new Intl.DateTimeFormat('en-GB', { timeZone: zone, weekday: 'short' })
		var value = formatter.format(date)
		var map = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }
		return map[value] || 1
	}

	function weekInZone(date) {
		var shifted = new Date(date.toLocaleString('en-US', { timeZone: zone }))
		var start = new Date(shifted.getFullYear(), 0, 1)
		return Math.ceil((((shifted - start) / 86400000) + start.getDay() + 1) / 7)
	}

	var daySync = weekdayInZone(baseDate)
	var weekSync = weekInZone(baseDate)
	var dayNow = weekdayInZone(nowDate)
	var weekNow = weekInZone(nowDate)
	var preferredDay = user.get_sync_day() || 1
	var preferredTime = user.get_sync_time() || 5

	if (user.get_upgrade()) {
		return ((daySync === dayNow) ? 'Tomorrow' : 'Today') + ', ' + times[preferredTime]
	}

	return (weekSync === weekNow) ? 'Next ' + days[preferredDay] : 'Today'
}

function buildResponse(user) {
	var insight = InsightUserSync.record({
		where: [
			['user_id', '=', user.get_id()]
		]
	})

	var history = []
	SyncResult.collection({
		where: [
			['result_signature', 'in', ['user/' + user.get_name(), 'deep/' + user.get_name()]]
		],
		order_by: 'result_date desc',
		limit: 10
	}).forEach(function(result) {
		history.push(historyRow(result.rawData()))
	})

	var lastAutoSync = SyncResult.record({
		where: [
			['result_signature', '=', 'user/' + user.get_name()],
			['result_priority', '>=', Constants.SYNC_PRIORITY_USER_AUTO],
			['result_priority', '<=', Constants.SYNC_PRIORITY_USER_AUTO_UPGRADE + 1]
		],
		order_by: 'result_date desc'
	})

	return {
		session: { offline: true },
		data: {
			daily: parseInt(!!user.get_upgrade(), 10),
			settings: {
				time: parseInt(user.get_sync_time() || 0, 10),
				day: parseInt(user.get_sync_day() || 0, 10),
				full: user.get_sync_type() === 2 ? 1 : 0,
				zone: user.get_sync_zone() || ''
			},
			summary: {
				last: parseInt(user.get_date_sync() || 0, 10),
				next: nextSyncText(user, lastAutoSync ? lastAutoSync.get_date() : 0),
				full: parseInt(user.get_date_sync_full() || 0, 10),
				deep: parseInt(user.get_date_sync_deep() || 0, 10)
			},
			history: history,
			metrics: {
				space: insight ? parseFloat(insight.get_space() || 0) : 0,
				syncs: {
					total: insight ? parseInt(insight.get_syncs_total() || 0, 10) : 0,
					standard: insight ? parseInt(insight.get_syncs_standard() || 0, 10) : 0,
					full: insight ? parseInt(insight.get_syncs_full() || 0, 10) : 0,
					deep: insight ? parseInt(insight.get_syncs_deep() || 0, 10) : 0
				},
				processing: {
					total: insight ? parseFloat(insight.get_time_process_total() || 0) : 0,
					standard: insight ? parseFloat(insight.get_time_process_standard() || 0) : 0,
					full: insight ? parseFloat(insight.get_time_process_full() || 0) : 0,
					deep: insight ? parseFloat(insight.get_time_process_deep() || 0) : 0
				},
				scraping: {
					total: insight ? parseFloat(insight.get_time_scrape_total() || 0) : 0,
					standard: insight ? parseFloat(insight.get_time_scrape_standard() || 0) : 0,
					full: insight ? parseFloat(insight.get_time_scrape_full() || 0) : 0,
					deep: insight ? parseFloat(insight.get_time_scrape_deep() || 0) : 0
				},
				data: {
					total: insight ? parseInt(insight.get_size_total() || 0, 10) : 0,
					standard: insight ? parseInt(insight.get_size_standard() || 0, 10) : 0,
					full: insight ? parseInt(insight.get_size_full() || 0, 10) : 0,
					deep: insight ? parseInt(insight.get_size_deep() || 0, 10) : 0
				}
			}
		}
	}
}

export default function(params) {
	var method = params.__offlineMethod || 'GET'
	var user = currentUser(params)

	if (!user) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	if (method === 'GET') {
		return Promise.resolve(buildResponse(user))
	}

	if (method === 'PUT') {
		DB.run(
			'UPDATE user SET user_sync_zone = ?, user_sync_time = ?, user_sync_day = ?, user_sync_type = ? WHERE user_id = ?',
			[
				params.zone || '',
				parseInt(params.time || 0, 10),
				parseInt(params.day || 0, 10),
				params.full ? 2 : 1,
				user.get_id()
			]
		)

		return DB.save().then(function() {
			var freshUser = User.with_id(user.get_id())
			return buildResponse(freshUser)
		})
	}

	return Promise.reject({ error: 'This action is not available offline.', offline: true })
}
